var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6404 6.35324C16.8025 5.5077 15.7853 4.8612 14.6639 4.46148C13.5426 4.06175 12.3459 3.919 11.162 4.04379C7.49285 4.4137 4.47356 7.39299 4.06366 11.0621C3.51379 15.911 7.2629 20 11.9918 20C13.5015 20 14.9803 19.5716 16.2563 18.7646C17.5322 17.9576 18.553 16.8052 19.2001 15.4411C19.52 14.7712 19.0401 14.0014 18.3003 14.0014C17.9304 14.0014 17.5805 14.2014 17.4205 14.5313C16.84 15.78 15.8472 16.7907 14.6091 17.3934C13.3709 17.9961 11.963 18.154 10.6221 17.8405C8.40263 17.3506 6.61306 15.5411 6.14317 13.3216C5.94565 12.4441 5.94793 11.5333 6.14986 10.6568C6.35179 9.78029 6.74819 8.96037 7.30974 8.25771C7.8713 7.55505 8.58363 6.98762 9.39407 6.5974C10.2045 6.20718 11.0923 6.00415 11.9918 6.00332C13.6514 6.00332 15.131 6.69316 16.2108 7.7829L14.7011 9.29254C14.0713 9.92239 14.5112 11.0021 15.401 11.0021H18.9901C19.54 11.0021 19.9899 10.5522 19.9899 10.0024V6.41322C19.9899 5.52343 18.9101 5.07354 18.2803 5.70339L17.6404 6.35324Z",
    fill: "#D6BCFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewRefresh);
export default __webpack_public_path__ + "static/media/PreviewRefresh.af4f203ce9d1bd367ae761e66d8d5138.svg";
export { ForwardRef as ReactComponent };